import React from 'react';

import { LocalizedMessage } from 'core/l10n/components';

export interface ESignDisclosureProps {
    linkText?: string | null;
    showAcceptDisclosure: boolean;
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
    onLinkClick?: () => void;
}

const ESignDisclosure: React.FunctionComponent<ESignDisclosureProps> = (props) => {
    if (!props.linkText) {
        return null;
    }
    return (
        <div>
            <div className="small">
                <div className="scrollable scrollable--max-short">
                    <p style={{ whiteSpace: 'pre-wrap' }}>
                        <LocalizedMessage id="claimDetail_body_reviewESignDisclosure" />
                    </p>
                    <p style={{ whiteSpace: 'pre-wrap' }}>
                        <a href={props.linkText} target="_blank" rel="noopener noreferrer" onClick={props.onLinkClick}>
                            <LocalizedMessage id="eSignDisclosureDocument_link" />
                        </a>
                    </p>
                </div>
            </div>
            <div className={`pt-2 form-check ${props.showAcceptDisclosure ? '' : 'visually-hidden'}`}>
                <label>
                    <input {...props.inputProps} type="checkbox" className="form-check-input" />
                    <LocalizedMessage id="claimDetail_label_eSignAcceptDisclosure" />
                    <span className="invalid-feedback">
                        <LocalizedMessage id="claimDetail_label_eSignCheckboxSelected" />
                    </span>
                </label>
            </div>
        </div>
    );
};

export default ESignDisclosure;
